<template>
  <div class="app-card" :class="cardClasses" :style="cardStyle">
    <div v-if="$slots.header || imgSrc" class="app-card__header" :class="headerClasses" :style="headerStyle">
      <img v-if="imgSrc" :src="imgSrc" :alt="imgAlt" class="app-card__img app-card__img--top" />
      <slot name="header" />
    </div>
    <div v-if="title || subtitle || $slots.header" class="app-card__title-section">
      <h5 v-if="title" class="app-card__title">{{ title }}</h5>
      <h6 v-if="subtitle" class="app-card__subtitle">{{ subtitle }}</h6>
    </div>
    <div v-if="!noBody" class="app-card__body">
      <slot />
    </div>
    <slot v-else />
    <div v-if="$slots.footer" class="app-card__footer" :class="footerClasses" :style="footerStyle">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { VARIANT_COLORS } from './variants.js'

export default {
  name: 'AppCard',
  inheritAttrs: false,
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    variant: { type: String, default: null },
    textVariant: { type: String, default: null },
    borderVariant: { type: String, default: null },
    headerVariant: { type: String, default: null },
    headerTextVariant: { type: String, default: null },
    footerVariant: { type: String, default: null },
    footerTextVariant: { type: String, default: null },
    imgSrc: { type: String, default: '' },
    imgAlt: { type: String, default: '' },
    imgTop: { type: Boolean, default: false },
    imgBottom: { type: Boolean, default: false },
    noBody: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false }
  },
  emits: ['click'],
  computed: {
    cardClasses() {
      return {
        'app-card--clickable': !!this.$attrs.onClick || this.$attrs.to || this.$attrs.href
      }
    },
    cardStyle() {
      const s = {}
      if (this.variant) {
        const c = VARIANT_COLORS[this.variant]
        if (c) { s.backgroundColor = c.bg }
      }
      if (this.textVariant) {
        const c = VARIANT_COLORS[this.textVariant]
        if (c) { s.color = c.bg === '#fff' ? '#212529' : c.text }
      }
      if (this.borderVariant) {
        const c = VARIANT_COLORS[this.borderVariant]
        if (c) { s.borderColor = c.border }
      }
      return s
    },
    headerClasses() {},
    headerStyle() {
      const s = {}
      if (this.headerVariant) {
        const c = VARIANT_COLORS[this.headerVariant]
        if (c) { s.backgroundColor = c.bg }
      }
      if (this.headerTextVariant) {
        const c = VARIANT_COLORS[this.headerTextVariant]
        if (c) { s.color = c.text }
      }
      return s
    },
    footerClasses() {},
    footerStyle() {
      const s = {}
      if (this.footerVariant) {
        const c = VARIANT_COLORS[this.footerVariant]
        if (c) { s.backgroundColor = c.bg }
      }
      if (this.footerTextVariant) {
        const c = VARIANT_COLORS[this.footerTextVariant]
        if (c) { s.color = c.text }
      }
      return s
    }
  }
}
</script>

<style scoped>
.app-card {
  border: 1px solid rgba(0,0,0,0.125);
  border-radius: 0.375rem;
  background: #fff;
  overflow: hidden;
}
.app-card--clickable { cursor: pointer; transition: box-shadow 0.2s; }
.app-card--clickable:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.15); }

.app-card__header {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid rgba(0,0,0,0.125);
  font-weight: 500;
}
.app-card__header:first-child { border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0; }

.app-card__img--top {
  width: 100%;
  display: block;
  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}

.app-card__title-section { padding: 0.75rem 1.25rem 0; }
.app-card__title { margin: 0; font-size: 1.25rem; }
.app-card__subtitle { margin: 4px 0 0; font-size: 0.875rem; color: #6c757d; }

.app-card__body { padding: 1.25rem; }
.app-card__body > :first-child { margin-top: 0; }
.app-card__body > :last-child { margin-bottom: 0; }

.app-card__footer {
  padding: 0.75rem 1.25rem;
  border-top: 1px solid rgba(0,0,0,0.125);
}
.app-card__footer:last-child { border-radius: 0 0 calc(0.375rem - 1px) calc(0.375rem - 1px); }
</style>
